const menu = [
  {
    header: "Settings",
    action: [
      "ROLE_SUPER_USER",
      "ROLE_PERFIL_CONSULTAR",
      "ROLE_ADM_CONSULTAR",
      "ROLE_ATEND_CONSULTAR",
      "ROLE_FINAN_CONSULTAR",
      "ROLE_PROTOCOLO_CONSULTAR",
      "ROLE_ORD_CONSULTAR",
    ],
    resource: "ACL",
  },
  {
    title: "Register",
    icon: "UserCheckIcon",
    action: "ROLE_ADM_CONSULTAR",
    resource: "ACL",
    children: [
      {
        title: "Administrative",
        route: "administrativeSettings",
        action: "ROLE_ADM_CONSULTAR",
        resource: "ACL",
      },
      {
        title: "Attendance",
        route: "attendanceSettings",
        action: "ROLE_ATEND_CONSULTAR",
        resource: "ACL",
      },
      {
        title: "Events",
        route: "eventsSettings",
        action: "ROLE_EVENTOS_CONSULTAR",
        resource: "ACL",
      },
      {
        title: "Financial",
        route: "financialSettings",
        action: "ROLE_FINAN_CONSULTAR",
        resource: "ACL",
      },
      {
        title: "Protocol",
        route: "protocolSettings",
        action: "ROLE_PROTOCOLO_CONSULTAR",
        resource: "ACL",
      },
      {
        title: "Service Orders",
        route: "ordemServicoSettings",
        action: "ROLE_ORD_CONSULTAR",
        resource: "ACL",
      },
    ],
  },
  {
    title: "Configurations",
    icon: "ToolIcon",
    action: "ROLE_SUPER_USER",
    resource: "ACL",
    children: [
      {
        title: "Client",
        route: "settings-client",
        action: "ROLE_SUPER_USER",
        resource: "ACL",
      },
      {
        title: "Directorship",
        route: "settings-diretoria",
        action: "ROLE_SUPER_USER",
        resource: "ACL",
      },
    ],
  },
  {
    title: "Audit",
    icon: "ShieldIcon",
    action: "ROLE_AUDITORIA_CONSULTAR",
    resource: "ACL",
    children: [
      {
        title: "Logs",
        route: "audit-logs",
        action: "ROLE_AUDITORIA_CONSULTAR",
        resource: "ACL",
      },
    ],
  },
  {
    title: "Access",
    icon: "UserIcon",
    action: ["ROLE_SUPER_USER", "ROLE_PERFIL_CONSULTAR"],
    resource: "ACL",
    children: [
      {
        title: "Users",
        route: "usersSettings",
        action: "ROLE_SUPER_USER",
        resource: "ACL",
      },
      {
        title: "Profile",
        route: "profileSettings",
        action: "ROLE_PERFIL_CONSULTAR",
        resource: "ACL",
      },
    ],
  },
];

export default menu;
